import { FORUM_LEGACY_STORAGE_KEY, FORUM_STORAGE_KEY } from './communityForumStore';

/** Единственный пользователь с доступом к dev-mode сообщества */
export const COMMUNITY_DEV_ADMIN_EMAIL = 'a.zaytsev@zarya.vc';

export const COMMUNITY_DEV_MODE_STORAGE_KEY = 'dc-community-dev-mode';
export const COMMUNITY_PREVIEW_AS_USER_KEY = 'dc-community-preview-as-user';
export const MARKET_PROFILE_DEV_PRESET_KEY = 'dc-market-profile-dev-preset';

/** Dev-пресет состояния профиля рынка (только для COMMUNITY_DEV_ADMIN_EMAIL) */
export type MarketProfileDevPreset = 'empty' | 'pending_review' | 'access_granted';

export const MARKET_PROFILE_DEV_PRESET_LABELS: Record<MarketProfileDevPreset, string> = {
  empty: 'Не заполнена',
  pending_review: 'На проверке',
  access_granted: 'Доступ выдан',
};

export function getMarketProfileDevPreset(): MarketProfileDevPreset | null {
  try {
    const raw = localStorage.getItem(MARKET_PROFILE_DEV_PRESET_KEY);
    if (raw === 'empty' || raw === 'pending_review' || raw === 'access_granted') return raw;
    return null;
  } catch {
    return null;
  }
}

export function setMarketProfileDevPresetStorage(preset: MarketProfileDevPreset | null) {
  try {
    if (preset) localStorage.setItem(MARKET_PROFILE_DEV_PRESET_KEY, preset);
    else localStorage.removeItem(MARKET_PROFILE_DEV_PRESET_KEY);
  } catch {
    /* ignore */
  }
}

export function isCommunityDevUser(email: string | null | undefined): boolean {
  return (email ?? '').trim().toLowerCase() === COMMUNITY_DEV_ADMIN_EMAIL;
}

/** Префикс для mock-данных forum UI v2 */
export const LS = `localStorage:${FORUM_STORAGE_KEY}`;

/** Пути хранения — показываются inline в dev-mode (как dbField в admin) */
export const P = {
  headers: `${LS}.headers[]`,
  headerTitle: `${LS}.headers[].title`,
  headerSortOrder: `${LS}.headers[].sortOrder`,
  headerStatus: `${LS}.headers[].status`,

  forums: `${LS}.forums[]`,
  forumHeaderId: `${LS}.forums[].headerId`,
  forumName: `${LS}.forums[].name`,
  forumDescription: `${LS}.forums[].description`,
  forumIcon: `${LS}.forums[].icon`,
  forumType: `${LS}.forums[].type`,
  forumCreateTopicsAccess: `${LS}.forums[].createTopicsAccess`,
  forumReplyAccess: `${LS}.forums[].replyAccess`,

  chats: `${LS}.chats[]`,
  chatHeaderId: `${LS}.chats[].headerId`,
  chatName: `${LS}.chats[].name`,
  chatDescription: `${LS}.chats[].description`,
  chatPostAccess: `${LS}.chats[].postAccess`,

  chatMessages: `${LS}.chatMessages[]`,
  chatMessageBody: `${LS}.chatMessages[].body`,
  chatMessageAuthor: `${LS}.chatMessages[].author`,

  topics: `${LS}.topics[]`,
  topicSectionId: `${LS}.topics[].sectionId → forums[].id`,
  topicTitle: `${LS}.topics[].title`,
  topicDescription: `${LS}.topics[].description`,
  topicTags: `${LS}.topics[].tags[]`,
  topicAuthor: `${LS}.topics[].author`,
  topicStatus: `${LS}.topics[].status`,
  topicSummary: `${LS}.topics[].summary`,

  replies: `${LS}.replies[]`,
  replyTopicId: `${LS}.replies[].topicId → topics[].id`,
  replyBody: `${LS}.replies[].body`,
  replyAuthor: `${LS}.replies[].author`,

  legacyV1: `localStorage:${FORUM_LEGACY_STORAGE_KEY}`,
  isCommunityAdmin: 'API: GET /private-circle/community/channels → meta.isCommunityAdmin',
} as const;

export function entityRef(base: string, id: string) {
  return `${base} · id=${id}`;
}
